import {enUS, es} from "react-day-picker/locale";

import type {AppLocale} from "./index";

export function getDayPickerLocale(locale: AppLocale) {
  return locale === "es" ? es : enUS;
}

export function getIntlLocaleTag(locale: AppLocale): string {
  return locale === "es" ? "es" : "en-US";
}
